export default __webpack_public_path__ + "static/made-okine-sans-regular-ba736ed3b94d6b13e223c253a31b6243.woff2";